import { apiInstance } from "./api-instance";

export const postFeedback = async (feedbackText) => {
  const response = await apiInstance.post('/feedback', { text: feedbackText });

  return response.data;
}
